// Port of api/fuel/app/classes/filter/core/search/sort.php
export { sorted, sortReverse, sortPriority } from 'offline/filter/core/search/unit'

export function run(name, results) {
	var sortIndex = (results.meta && results.meta[name]) ? Object.assign({}, results.meta[name]) : {}

	if (name.indexOf('asc') !== -1) {
		Object.keys(sortIndex).sort(function(a, b) {
			if (sortIndex[a] < sortIndex[b]) return -1
			if (sortIndex[a] > sortIndex[b]) return 1
			return 0
		}).forEach(function() {})
	} else {
		Object.keys(sortIndex).sort(function(a, b) {
			if (sortIndex[a] < sortIndex[b]) return 1
			if (sortIndex[a] > sortIndex[b]) return -1
			return 0
		}).forEach(function() {})
	}

	var sortedIds = Object.keys(sortIndex).sort(function(a, b) {
		var av = sortIndex[a]
		var bv = sortIndex[b]
		if (name.indexOf('asc') !== -1) {
			if (av < bv) return -1
			if (av > bv) return 1
		} else {
			if (av < bv) return 1
			if (av > bv) return -1
		}
		return 0
	}).map(function(id) {
		return parseInt(id, 10)
	})

	for (var i = 0; i < results.index.length; i++) {
		var id = results.index[i]
		results.sortvalue[id] += '_' + sortIndex[id]
	}

	results.index = sortedIds
	return results
}

export function modifies() {
	return 'index'
}
